<template lang="pug">

  footer.px-3
    | &copy; 2019 - {{ currentYear }}

</template>

<script>

  export default {
    name: 'Footer',

    computed: {
      currentYear () {
        return new Date().getFullYear()
      },
    },
  }

</script>

<style lang="scss" scoped>

  footer {
    padding: 15px 0;

    color: #3c4858;
    font-size: 16px;
    font-weight: 300;
    letter-spacing: 0px;
    text-align: right;
  }

  @media (max-width: 768px) {
    footer {
      text-align: center;
    }
  }

</style>
